import type { CommentCommunication } from '@seen/core/models/communications/CommentCommunication'
import { ExtendedPractitioner } from '@seen/core/models/practitioner'
import { useCallback } from 'react'
import { useCommentRelatedParticipant } from '#src/hooks/useCommentRelatedParticipant.ts'
import { useRead } from '#src/hooks/useRead.ts'
import {
  type TaskComposerDefaultValues,
  useTaskComposerStore,
} from '#src/hooks/useTaskComposerStore.ts'
import { useTimelineItemUrl } from '#src/hooks/useTimelineItemUrl.ts'

export function useComposeTaskFromComment(
  comment: CommentCommunication
): () => void {
  const setOpen = useTaskComposerStore((state) => state.setOpen)
  const setDefaultValues = useTaskComposerStore(
    (state) => state.setDefaultValues
  )
  const commentUrl = useTimelineItemUrl(comment)
  const { data: sender } = useRead(
    ExtendedPractitioner,
    comment.practitionerSender
  )
  const participant = useCommentRelatedParticipant(comment)
  const callback = useCallback(() => {
    const selectedText = window.getSelection()?.toString()
    const defaultValues: TaskComposerDefaultValues = {
      basedOn: [comment.reference],
      description: `<p><a data-type="mention" data-reference="${sender?.reference.reference}">${sender?.name}${sender?.roles ? ` ${sender?.roles.join(', ')}` : ''}</a> said in <a href="${commentUrl}">comment</a>:</p><blockquote>${comment.message}</blockquote>`,
    }
    if (selectedText) {
      defaultValues.title = selectedText
    }
    if (participant) {
      defaultValues.participant = participant
    }
    setDefaultValues(defaultValues)
    setOpen(true)
  }, [setOpen, setDefaultValues, participant, sender, commentUrl, comment])
  return callback
}
